import cx from 'classnames';
import useTranslation from 'next-translate/useTranslation';
import React, { FunctionComponent, useState } from 'react';
import { UseFormRegister } from 'react-hook-form';

import Button from '../../ui/button';
import { CheckBox, Text } from '../../ui/inputs/generic-input';
import EyeOpen from '../../ui/icons/eye-open';
import EyeClose from '../../ui/icons/eye-close';

const SignUpFormContent: FunctionComponent<{
  register: UseFormRegister<Record<string, any>>;
  errors: Record<string, any>;
  disabled: boolean;
  isValid: boolean;
}> = ({ register, errors, disabled, isValid }) => {
  const { t } = useTranslation();
  const [inputType, setInputType] = useState('password');
  return (
    <>
      <div className='w-full lg:w-1/2'>
        <Text
          {...register('name', { required: t('forms:errors.required') })}
          label={t('forms:user.name.label')}
          id={`name`}
          placeholder={t('forms:user.name.placeholder')}
          disabled={disabled}
          error={errors?.name?.message}
        />
      </div>
      <div className='flex max-lg:flex-col gap-4 w-full'>
        <div className='w-full'>
          <Text
            {...register('email', {
              required: t('forms:errors.required'),
              maxLength: {
                value: 150,
                message: t('forms:errors.maxLenght', { value: 150 }),
              },
              pattern: {
                value: /^\S+@\S+$/i,
                message: t('forms:errors.invalidEmail'),
              },
            })}
            label={t('forms:user.email.label')}
            type="email"
            id={`email`}
            placeholder={t('forms:user.email.placeholder')}
            disabled={disabled}
            error={errors?.email?.message}
          />
        </div>
        <div className="relative grid items-center w-full">
          <Text
            {...register('password', {
              required: t('forms:errors.required'),
              minLength: {
                value: 6,
                message: t('forms:errors.minLenght', { value: 6 }),
              },
            })}
            label={t('forms:user.password.label')}
            type={inputType}
            id="password"
            placeholder={t('forms:user.password.placeholder')}
            error={errors?.password?.message}
            disabled={disabled}
            extraIcon
            autocomplete="current-password"
          />
          <Button
            isFullWidth={false}
            className={cx(
              'absolute',
              'top-0',
              'right-0',
              'hover:bg-neutral-30'
            )}
            onClick={() => {
              setInputType(inputType === 'password' ? 'text' : 'password');
            }}
            type="button"
          >
            {inputType === 'password' ? (
              <EyeOpen
                className={cx('text-neutral-80')}
                id="showPassword"
              ></EyeOpen>
            ) : (
              <EyeClose className={cx('w-4')}></EyeClose>
            )}
          </Button>
        </div>
      </div>
      <div className="flex w-full lg:w-1/2">
        <Button
          role="button"
          variant="CTA"
          data-action="submit"
          disabled={!isValid}
        >
          {t('signup:signup-btn')}
        </Button>
      </div>
    </>
  );
};
export default SignUpFormContent;
